module.exports = __webpack_public_path__ + "img/138.37a97774.jpg";